import jwt_decode from "jwt-decode";
import { Temporal } from "temporal-polyfill";
import IJwtToken from "../models/security/IJwtToken";
import Constants from "../models/utility/Constants";

export default class TokenProvider {
    public static GetStoredToken() {
        return this.getAndValidateToken(false) as string | null;
    }

    public static GetStoredTokenParsed() {
        return this.getAndValidateToken(true) as IJwtToken | null;
    }

    public static StoredTokenExpiredOrEmpty(): boolean {
        const token = this.getAndValidateToken(false);
        if (token) {
            return false;
        }

        return true;
    }

    public static SetStoredToken(token: string) {
        localStorage.removeItem(this.tokenStorageName);
        localStorage.setItem(this.tokenStorageName, token);
    }

    public static ClearStoredToken() {
        localStorage.removeItem(this.tokenStorageName);
    }

    public static ParseTokenString(tokenString: string): IJwtToken {
        return jwt_decode(tokenString) as IJwtToken;
    }

    public static TokenExistsButIsExpired(): boolean {
        const token = this.getParsedToken();
        if (token && this.tokenExpired(token)) return true;

        return false;
    }

    public static TokenExistsAndIsNotExpired(): boolean {
        const token = this.getParsedToken();
        if (token && !this.tokenExpired(token)) return true;

        return false;
    }

    public static TokenExists(): boolean {
        return !!this.getParsedToken();
    }

    private static readonly tokenStorageName = "JwtToken";

    private static getAndValidateToken(
        parsed: boolean
    ): IJwtToken | string | null {
        const token = localStorage.getItem(this.tokenStorageName) as string;
        if (!token) {
            return null;
        }

        // token is cleared from local storage if expired
        const parsedToken = jwt_decode(token) as IJwtToken;
        if (this.tokenExpired(parsedToken)) {
            this.ClearStoredToken();
            return null;
        }

        return parsed ? parsedToken : token;
    }

    private static getParsedToken(): IJwtToken | null {
        const token = localStorage.getItem(this.tokenStorageName) as string;
        if (!token) {
            return null;
        }

        return jwt_decode(token) as IJwtToken;
    }

    private static tokenExpired(token: IJwtToken): boolean {
        const timeStamp = token.exp;

        const expiry = Temporal.Instant.fromEpochMilliseconds(
            Math.trunc(timeStamp * 1000)
        );
        const now = Temporal.Instant.fromEpochMilliseconds(
            Constants.CurrentDate().getTime()
        );

        return Temporal.Instant.compare(expiry, now) <= 0;
    }
}
